/**
 * Full-circle loading spinner. Unlike `lucide-react`'s `Loader2` (which
 * only draws ~270° of a circle), this renders a complete ring with a
 * subtle transparent notch that reveals the rotation — no visible "gap"
 * or "arc that doesn't quite close".
 */
export function Spinner({ size = 16, className = "", stroke = 2, color = "currentColor" }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={`inline-block align-middle ${className}`}
      style={{
        width: size,
        height: size,
        border: `${stroke}px solid rgba(0,0,0,0.15)`,
        borderTopColor: color,
        borderRadius: "50%",
        animation: "reads-spin 0.7s linear infinite",
        boxSizing: "border-box",
      }}
      data-testid="spinner"
    />
  );
}
